import { Intersect } from './../math';
import { contains } from './../utils';
export class QuadRoot {
    constructor() {
        this.shapes = [];
    }
    _add(shape, bounds) {
        this.shapes.push({
            bounds: bounds,
            shape: shape
        });
        shape._quadNode = this;
    }
    insert(shape, bounds) {
        this._add(shape, bounds);
    }
    remove(shape) {
        const shapes = this.shapes;
        const length = shapes.length;
        for (let idx = 0; idx < length; idx++) {
            if (shapes[idx].shape === shape) {
                shapes.splice(idx, 1);
                break;
            }
        }
    }
    hitTestRect(rect, exclude) {
        const shapes = this.shapes;
        const length = shapes.length;
        for (let i = 0; i < length; i++) {
            if (this._testRect(shapes[i].shape, rect) && !contains(exclude, shapes[i].shape)) {
                return true;
            }
        }
    }
    _testRect(shape, rect) {
        const angle = shape.rotate().angle;
        const bounds = shape.bounds();
        let hit;
        if (!angle) {
            hit = bounds.overlaps(rect);
        }
        else {
            hit = Intersect.rects(rect, bounds, -angle);
        }
        return hit;
    }
}
